import InstagramAccountConnectButton from './sources/InstagramFeed';
import ShopConnectButton from './sources/Shop/Shop';
import TikTokConnectButton from './sources/TiktokFeed';
import YoutubeChannelConnectInput from './sources/YoutubeFeed';
import TwitterAccountConnectInput from './sources/TwitterFeed';
import TwitchChannelConnectInput from './sources/TwitchFeed';
import FacebookPageConnectButton from './sources/FacebookFeed';
import VimeoConnectButton from './sources/VimeoFeed';
import PinterestConnectButton from './sources/PinterestFeed';

export default {
    'instagram-feed': InstagramAccountConnectButton,
    'tiktok-feed': TikTokConnectButton,
    'youtube-feed': YoutubeChannelConnectInput,
    'twitter-feed': TwitterAccountConnectInput,
    'twitch-feed': TwitchChannelConnectInput,
    'facebook-feed': FacebookPageConnectButton,
    'vimeo-feed': VimeoConnectButton,
    'pinterest-feed': PinterestConnectButton,
    'shop': ShopConnectButton
}